import { createContext } from "react";

export interface ViewOrganizationContextState {
  id: string;
}

export const ViewOrganizationContext =
  createContext<ViewOrganizationContextState>({
    id: "",
  });
